/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';



/**
 * Application Insights telemetry forwarder.
 */
@Injectable({
  providedIn: 'root',
})
export class AppInsightsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation trackTelemetry
   */
  static readonly TrackTelemetryPath = '/v2/track';

  /**
   * Forward Application Insights telemetry from the frontend.
   *
   * Accepts Application Insights telemetry from the Angular frontend and forwards it to Application Insights using the server-side connection string.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `trackTelemetry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  trackTelemetry$Response(params: {
    'X-Forwarded-For'?: string;
    body: string
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AppInsightsService.TrackTelemetryPath, 'post');
    if (params) {
      rb.header('X-Forwarded-For', params['X-Forwarded-For'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Forward Application Insights telemetry from the frontend.
   *
   * Accepts Application Insights telemetry from the Angular frontend and forwards it to Application Insights using the server-side connection string.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `trackTelemetry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  trackTelemetry(params: {
    'X-Forwarded-For'?: string;
    body: string
  },
  context?: HttpContext

): Observable<void> {

    return this.trackTelemetry$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
